import { useAPIData } from 'hooks/useAPIData';

export function useAPIPlanSettings() {
    const apiData = useAPIData('/plans?per_page=1000', x => x, {});

    return apiData;
}
